import React from 'react';
import { Dialog, DialogTitle } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import useLiveOrderDetailsDialog from '../../hooks/dialogs/useLiveOrderDetailsDialog';
import { LiveOrderDetails } from '../liveOrderDetails/LiveOrderDetails';

const LiveOrderDetailsDialog: React.FC<{ open: boolean }> = (props) => {
    const liveOrderDetailsDialog = useLiveOrderDetailsDialog();

    if (!props.open) {
        return <></>;
    }

    return (
        <>
            <Dialog
                open={props.open}
                onClose={liveOrderDetailsDialog.closeDialog}
                maxWidth={'lg'}
                fullWidth
            >
                <DialogTitle
                    sx={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        alignItems: 'center',
                    }}
                >
                    <CloseIcon
                        sx={{ cursor: 'pointer' }}
                        onClick={liveOrderDetailsDialog.closeDialog}
                    />
                </DialogTitle>
                <LiveOrderDetails
                    liveOrder={liveOrderDetailsDialog.dialogContent}
                />
            </Dialog>
        </>
    );
};

export default LiveOrderDetailsDialog;
